import React from "react";
import * as styles from "./autocomplete.scss";
import MyMenigoIcon from "../../../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon";
import { epiPropertyValue } from "@avensia/nitro5-scope-episerver";
export default (props) => {
    return (React.createElement("div", { className: styles.newsBanner },
        React.createElement("div", { className: styles.iconColumn }, !!props.block.iconName && !!epiPropertyValue(props.block.iconName) && (React.createElement(MyMenigoIcon, { name: epiPropertyValue(props.block.iconName).toLowerCase() }))),
        React.createElement("div", { className: styles.headerColumn },
            React.createElement("strong", null, epiPropertyValue(props.block.header))),
        React.createElement("div", { className: styles.textColumn },
            React.createElement("p", null, !!props.block.text && epiPropertyValue(props.block.text)),
            React.createElement("span", { className: styles.linkColumn }, !!props.block.link && (React.createElement("a", { href: epiPropertyValue(props.block.link).url },
                props.ctaText,
                " ",
                React.createElement(MyMenigoIcon, { name: "arrow" })))))));
};
